import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import './styles.scss';
import Shimmer from '../Shimmer/Shimmer';
import MenuPageHeader from '../MenuPageHeader';
import useAuth from '../../hooks/useAuth';
import couponImage from '../../common/assets/svg/coupon.svg';
import { ReactComponent as CouponImage } from '../../common/assets/svg/offersCouponimg.svg';
import PercentageImage from '../../common/assets/svg/percentageimg.svg';
import Dollarimg from '../../common/assets/svg/dollarimg.svg';
import freeItemimg from '../../common/assets/svg/freeitemimg.svg';
import freeDeliveryimg from '../../common/assets/svg/freedeliveryimg.svg';
import clearcoupon from '../../common/assets/svg/clearCoupon.svg';
import rotatingloader from '../../common/assets/svg/rotatingloader.svg';
import tickIconOffer from '../../common/assets/svg/tickIconOffer.svg';

import locakimg from '../../common/assets/svg/offerLockimg.svg';

import CouponDetailsModal from '../couponPopups/CouponDetailsModal';
import CouponSuccessPopup from '../couponPopups/CouponSuccessModal';
import backArrow from '../../common/assets/svg/BackTopArrow.svg';
import { useDispatch } from 'react-redux';
import {
  clearPlaceOrderLoading,
  couponClicked,
  getCustomerOffersRequest,
  removeCartTip,
  setNotip,
  setTipAdded,
  toggleCartView,
} from '../../common/features/cart/cartActions';
import notFound from '../../common/assets/svg/noOffersImagenew.svg';
import {
  appliedCoupon,
  clearAppliedCoupon,
  validateCouponClearmsg,
  validateCouponRequest,
} from '../../common/features/restaurant/restaurantAction';
import { useLocation, useNavigate, useParams } from 'react-router';
import InvalidCoupon from '../couponPopups/InvalidCoupon';
import CouponAppliedModal from '../couponPopups/CouponAppliedModal';
import CouponRemovePopup from '../couponPopups/CouponRemovePopup';
import { getCookie } from '../../helper/cookieHelper';
import { USER_ID } from '../../common/constants';
import {
  isCouponApplied,
  getOfferCategory,
  isExclusiveCoupon,
  hasExclusiveApplied,
  cartHasExclusiveItemOffer,
  getItemLevelOfferIds,
  dismissOfferAtSubtotal,
  clearOfferDismissal,
  suppressAllAutoApply,
  wasAutoApplied,
  bogoEqualOrLesserSatisfied,
  computeRawCartSubtotal,
  filterOffersByOrderType,
  buildOfferCaptureRequests,
  buildFreeItemOrderLines,
  isMenuItemOrderable,
} from '../../common/utils/offer-utils';
import { showErrorToast, showErrorToastDesktop } from '../../common/utils/toastUtils';
import { manageItemTotalsHelper } from '../../helper/orderToatals.helper';
import { savePlaceOrderDetails } from '../../common/features/order/orderActions';
interface CouponData {
  setShowSuccessPopup?: any;
  showSuccessPopup?: any;
}

const CouponList: React.FC<CouponData> = ({ setShowSuccessPopup, showSuccessPopup }) => {
  const restaurantDetailLoading = useSelector(
    (state: any) => state.restaurant.restaurantDetailLoading
  );
  const [couponCardapplyClicked, setCouponCardapplyClicked] = useState(false);
  // Pending coupon for the "Remove offer" confirmation popup. Set when the
  // user clicks Remove on an applied coupon card; cleared on Keep or after
  // the actual removal is dispatched.
  const [pendingRemoveCoupon, setPendingRemoveCoupon] = useState<any>(null);
  const appliedCouponsList = useSelector(
    (state: any) => state.restaurant.appliedCoupons || []
  );
  const couponValidationmsg = useSelector((state: any) => state.restaurant.validateCouponmsg);
  const promoLoaderStopCount = useSelector((state: any) => state.restaurant.promoLoaderStopCount || 0);
  const isCartViewVisible = useSelector((state: any) => state.cart.isCartViewVisible);
  const [promoApplySuccess, setPromoApplySuccess] = useState(false);
  const [promoLoading, setPromoLoading] = useState(false);


  const cart = useSelector((state: any) => state.cart.cart.items);
  const cartItemsFromApi = useSelector((state: any) => state.cart.cartItems);

  // Item IDs whose API entry has enabled:false (not available for current order type).
  const disabledItemIds = useMemo(() => {
    if (!Array.isArray(cartItemsFromApi) || !Array.isArray(cart)) return [] as string[];
    const ids: string[] = [];
    cart.forEach((item: any) => {
      const apiItem = cartItemsFromApi.find((i: any) => i?.itemId === item?.itemId);
      if (apiItem && apiItem.enabled === false) ids.push(item.itemId);
    });
    return ids;
  }, [cartItemsFromApi, cart]);

const restaurantMenuDetails = useSelector(
    (state: any) => state.restaurant.restaurantMenuDetails
  );
  // True when any cart item has an item-level offer with combineOffer=true,
  // which forbids stacking any coupon on top.
  const itemLevelExclusiveActive = cartHasExclusiveItemOffer(cart, restaurantMenuDetails);
  const location = useLocation();
  const restaurantDetails = useSelector((state: any) => state.restaurant.currentRestaurantDetail);
  const restaurantOrderTypeId = useSelector((state: any) => state.restaurant.restaurantOrderTypeId);
  const { merchantType, merchantSlug, menuType, tableId } = useParams();
  const navigate = useNavigate();
  const couponsListLoading = useSelector((state: any) => state.cart.customerOffersLoading);
  const couponsListSuccess = useSelector((state: any) => state.cart.customerOffersSuccess);
  const couponsListFaliure = useSelector((state: any) => state.cart.customerOffersFailure);
  const couponsList = useSelector((state: any) => state.cart.customerOffers);
  
  const isMobile = useSelector((state: any) => state?.navigation?.isMobile);
  const [signupPopup, setSignupPopup] = useState(false);
  const [showSuccessPopupMobile, setShowSuccessPopupMobile] = useState<boolean>();
  const [showCouponDetailsPopup, setShowCouponDetailsPopup] = useState(false);
  const isEventDate = useSelector((state: any) => state.cart.isEventDate);
  const [showCouponPopup, setShowCouponPopup] = useState(false);


  const { handleLogout } = useAuth();
  const dispatch = useDispatch();

  const slugFromLocalStorage =
    localStorage?.getItem('restaurant') && JSON?.parse(localStorage?.getItem('restaurant') || '');
  const locationID = useSelector((state: any) => state.restaurant.currentRestaurantDetail.id);
  const UserId = getCookie(USER_ID);
  const eventName = localStorage.getItem('isEventOrder') || '';
  const customerId = getCookie(USER_ID);
  const userIdFromAuth = useSelector((state: any) => state.auth?.user?.id ?? '');
  const tipValue = useSelector((state: any) => state.cart.tipValue);
  const tipType = useSelector((state: any) => state.cart.tipType);
  // Promo codes the user typed for item-level offers, keyed by offerId — those
  // offers live on cart entries, not in appliedCoupons, so this is the only
  // source of their code for offerCaptureRequests.
  const itemLevelPromoCodes = useSelector((state: any) => state.cart.itemLevelPromoCodes);
  const totalsRequestIdRef = useRef(0);
  // Call totals API whenever applied offers change on the standalone /coupons route.
  // mobileCart handles this when it's mounted; this covers the case where it's not.
  useEffect(() => {
    if (!Array.isArray(cart) || cart.length === 0) return;
    if (!restaurantDetails?.id) return;

    const fetchTotals = async () => {
      totalsRequestIdRef.current += 1;
      const reqId = totalsRequestIdRef.current;
      const eligibleCoupons = filterOffersByOrderType(appliedCouponsList, restaurantOrderTypeId);
      const freeItemOrderLines = buildFreeItemOrderLines(eligibleCoupons, restaurantMenuDetails);
      const availableCart = cart.filter(
        (item: any) => !disabledItemIds?.includes(item?.itemId)
      );
      const payload = {
        discount: 0,
        discountType: 'FLATFEE',
        orderItems: [...availableCart, ...freeItemOrderLines],
        orderTypeId: restaurantOrderTypeId,
        locationId: restaurantDetails.id,
        tip: tipValue,
        tipType: tipType,
        offerCaptureRequests: buildOfferCaptureRequests(eligibleCoupons, cart, restaurantMenuDetails, itemLevelPromoCodes),
        customerId: getCookie(USER_ID) || userIdFromAuth || null,
      };
      const data = await manageItemTotalsHelper(payload, dispatch, appliedCouponsList);
      if (!data || reqId !== totalsRequestIdRef.current) return;
      const freeIds = new Set(freeItemOrderLines.map((f: any) => f.itemId));
      const baseItems = Array.isArray(data?.orderItems) ? data.orderItems : [];
      dispatch(savePlaceOrderDetails({
        discountValue: Number(data?.orderTotals?.find((t: any) => t.code === '6' || t.code === '6.0')?.value) || 0,
        discountType: 'FLATFEE',
        totals: data?.orderTotals,
        orderTotal: data?.orderTotal,
        orderItems: [
          ...baseItems.filter((i: any) => !(freeIds.has(i?.itemId) && i?.offer_data?.isFreeItem)),
          ...freeItemOrderLines,
        ],
        tip: tipValue,
        tipType: tipType,
        deliveryFee: 0,
        orderTypeId: restaurantOrderTypeId,
      }));
    };

    fetchTotals();
  }, [appliedCouponsList, cart, restaurantOrderTypeId, tipValue, tipType, userIdFromAuth, disabledItemIds, itemLevelPromoCodes]);

  useEffect(() => {
    if (cart?.length < 1 && location?.pathname?.includes('/coupons')) {
      dispatch(setNotip(''));
      dispatch(setTipAdded(false));
      dispatch(removeCartTip());
      if (!tableId) {
        if (isEventDate) {
          navigate(
            `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/menu/${slugFromLocalStorage?.menuType}/event/${eventName}`
          );
        } else {
          navigate(
            `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/menu/${slugFromLocalStorage?.menuType}`
          );
        }
      } else {
        navigate(
          `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/table/${tableId}/menu/${slugFromLocalStorage?.menuType}`
        );
      }
    }
  }, [cart]);
  const [couponState, setCouponState] = useState();
  const [couponSearch, setCouponSearch] = useState('');
  const [couponSearchError, setCouponSearchError] = useState<any>();
  const totals = useSelector((state: any) => state.cart.totalDetails);
  const itemTotal = totals?.orderTotals?.find((t: any) => t.code === '1')?.value;
  const availableSubTotal = useMemo(() => {
    const availableItems = (cart || []).filter(
      (item: any) => !disabledItemIds.includes(item?.itemId)
    );
    return computeRawCartSubtotal(availableItems);
  }, [cart, disabledItemIds]);
  const selectedCouponId = (Array.isArray(couponsList) ? couponsList : []).filter((item: any) => item.offerCode === couponSearch);


  useEffect(() => {
    setPromoLoading(false);
    if (couponValidationmsg && couponValidationmsg.httpStatus === 400) {
      if (couponSearch !== '') {
        // "Offer not found" (code doesn't exist / not in the offers list) is
        // surfaced to the user as "Invalid promo code". Other 400 validation
        // failures (e.g. minimum-order-not-met) keep their own API message.
        const isNotFound =
          couponValidationmsg?.offerDetails == null ||
          String(couponValidationmsg?.message || '')
            .toLowerCase()
            .includes('not found');
            
            
        setCouponSearchError(
          isNotFound
            ? { ...couponValidationmsg, message: couponValidationmsg?.message }
            : couponValidationmsg
        );
        // setCouponCardapplyClicked(false);
      }
    } else {
      if (couponValidationmsg && couponValidationmsg.httpStatus === 200) {
        // Promo applied. The saga already applied the FULL matched offer from
        // the offers list (card highlights via id; the cart-page celebration
        // queue has the complete offer shape). Skip the offers-panel success
        // popup and send the user to the cart page, where the offer popup fires
        // — consistent with the card-apply flow. Clear the validate message so
        // a later remount of the offers panel doesn't re-navigate.
        setPromoApplySuccess(true);
        setCouponState(selectedCouponId[0]);
        dispatch(validateCouponClearmsg());
        // Stay on the coupons page after promo apply (both mobile and desktop).
      }
      setCouponSearchError('');
    }
  }, [couponValidationmsg]);

  useEffect(() => {
    if (promoLoaderStopCount > 0) setPromoLoading(false);
  }, [promoLoaderStopCount]);

  useEffect(() => {
    if (couponValidationmsg && couponValidationmsg.httpStatus=== 400 && couponCardapplyClicked) {
      
      setShowCouponPopup(true);
    } else {
      setShowCouponPopup(false);
    }
  }, [couponValidationmsg, couponCardapplyClicked]);

  // Shared "apply this offer" action used by BOTH the coupon card and the
  // details popup so they apply identically: clear this offer's dismissal +
  // the global auto-apply suppression, then dispatch appliedCoupon (FREE_ITEM
  // offers get their first free item chosen). Reducer stacks/replaces by
  // category (ORDER/FREE_ITEM/FREE_DELIVERY).
  const applyOfferLikeCard = (offer: any) => {
    console.log({offer});

    if (!offer) return;

    const incomingOfferCat = getOfferCategory(offer);

    // Pre-apply guard: order-level offers are not applicable for event orders.
    if (incomingOfferCat === 'ORDER' && isEventDate) {
      const msg = 'This offer is not applicable for event orders';
      isMobile ? showErrorToast(msg) : showErrorToastDesktop(msg);
      return;
    }

    // Pre-apply guard: block if an exclusive offer is already applied.
    // Item-level (FREE_ITEM) offers always coexist with other categories, so
    // exclusivity never blocks them.
    if (incomingOfferCat !== 'FREE_ITEM') {
      const existingExclusive = (Array.isArray(appliedCouponsList) ? appliedCouponsList : []).find(
        (c: any) => isExclusiveCoupon(c)
      );
      if (existingExclusive && existingExclusive?.id !== offer?.id) {
        const msg = 'Other offer is applied';
        isMobile ? showErrorToast(msg) : showErrorToastDesktop(msg);
        return;
      }
    }

    // Pre-apply guard: block if qualifying items (non-disabled, non-free) are
    // insufficient for this offer.
    const offerTypeUpper = String(offer?.offer_type || offer?.offerType || '').toUpperCase();
    const isFreeDeliveryOffer = offerTypeUpper === 'FREE_DELIVERY';
    if (!isFreeDeliveryOffer) {
      const cartItems = Array.isArray(cart) ? cart : [];
      const hasAnyPurchasedItem = cartItems.some(
        (item: any) => !item?.offer_data?.isFreeItem
      );
      const hasQualifyingItem = cartItems.some(
        (item: any) => !disabledItemIds.includes(item?.itemId) && !item?.offer_data?.isFreeItem
      );
      if (hasAnyPurchasedItem && !hasQualifyingItem) {
        const msg = 'Some items are not available for the selected order type';
        isMobile ? showErrorToast(msg) : showErrorToastDesktop(msg);
        return;
      }
    }

    setCouponCardapplyClicked(true);
    setCouponState(offer);
    sessionStorage.removeItem('autoApplyDismissed');
    clearOfferDismissal(offer?.id);
    if (offer?.id) {
      sessionStorage.setItem('autoApplyModalShownFor', offer.id);
    }
    const payload =
      getOfferCategory(offer) === 'FREE_ITEM' &&
      Array.isArray(offer?.freeList) &&
      offer.freeList.length > 0
        ? { ...offer, _chosenFreeItemId: offer.freeList[0] }
        : offer;
        console.log("ghgh pay",payload);
        
    dispatch(appliedCoupon(payload));
  };

  const CouponCard = ({ couponDetails }: any) => {
    // Detect whether the (line-clamped) description overflows so "View more"
    // only shows when there's actually hidden text.
    const descRef = useRef<HTMLParagraphElement | null>(null);

    const orderTypeApplicable =
      !Array.isArray(couponDetails?.orderTypeIds) ||
      couponDetails.orderTypeIds.length === 0 ||
      couponDetails.orderTypeIds.includes(restaurantOrderTypeId);
    const isFlatFee = couponDetails?.offer_type === 'FLAT';
    const couponCategory = getOfferCategory(couponDetails);

    // Card icon. For FREE_ITEM, prefer the first freeList item's menu image
    // (e.g. a real Pepsi can image). Fall back to the freeItemimg asset.
    let cardIconSrc: string;
    let cardIconClassName = 'couponCard-icon couponCard-icon--photo';
    if (couponCategory === 'FREE_DELIVERY') {
      cardIconSrc = freeDeliveryimg;
    } else if (couponCategory === 'FREE_ITEM') {
      const firstFreeItemId = Array.isArray(couponDetails?.freeList)
        ? couponDetails.freeList[0]
        : null;
      const firstFreeMenuItem = firstFreeItemId && Array.isArray(restaurantMenuDetails)
        ? restaurantMenuDetails.find((m: any) => m?.itemId === firstFreeItemId)
        : null;
      // v2 menu nests image data under itemMedia[0]; legacy shape exposes
      // itemImage / itemType directly on the item.
      const media = Array.isArray(firstFreeMenuItem?.itemMedia)
        ? firstFreeMenuItem.itemMedia[0]
        : null;
      const imageId = media?.itemImage ?? firstFreeMenuItem?.itemImage ?? null;
      const imageType = media?.itemType ?? firstFreeMenuItem?.itemType ?? null;
      const itemImageUrl =
        imageId && imageType
          ? `${process.env.REACT_APP_IMAGE_URL}img/${imageId}.${String(imageType).split('/')[1] || imageType}`
          : null;
      cardIconSrc = itemImageUrl || freeItemimg;
      cardIconClassName = 'couponCard-icon couponCard-icon--photo';
    } else {
      cardIconSrc = isFlatFee ? Dollarimg : PercentageImage;
    }

    const currencySymbol = restaurantDetails?.country === 'IN' ? '₹' : '$';

    const offerRate = parseFloat(couponDetails?.discount_value);

    const formattedRate = isFlatFee
      ? offerRate.toFixed(2)
      : Number.isInteger(offerRate)
        ? offerRate
        : offerRate;

    const baseOfferText = isFlatFee
      ? `Flat ${currencySymbol}${formattedRate} Off`
      : `${formattedRate}% Off`;
    const minSubtotal = Number(couponDetails?.min_subtotal);
    const isFreeItemCoupon = couponCategory === 'FREE_ITEM';
    const freeItemFallbackText = minSubtotal > 0
      ? `Get a Free Item on orders above ${currencySymbol}${minSubtotal.toFixed(2)}`
      : `Get a Free Item with your order`;
    const offerText = isFreeItemCoupon
      ? freeItemFallbackText
      : minSubtotal > 0
        ? `${baseOfferText} for order value above ${currencySymbol}${minSubtotal.toFixed(2)}`
        : baseOfferText;
    const isThisCouponApplied = isCouponApplied(appliedCouponsList, couponDetails?.id);
    // Exclusivity: a coupon with combineOffer === true cannot coexist
    // with any other applied coupon. So this card is blocked when…
    //   - an exclusive is already applied and this card isn't it, OR
    //   - this card is exclusive and any other (non-exclusive) coupon is applied.
    // (An exclusive can still replace existing non-exclusives — the reducer
    //  handles the swap — but we surface this as a blocked Apply for clarity.)
    const exclusiveActive = hasExclusiveApplied(appliedCouponsList);
    const thisIsExclusive = isExclusiveCoupon(couponDetails);
    // FREE_ITEM never occupies the exclusivity slot — it coexists with
    // everything, so it shouldn't count as "something else is applied".
    const hasAppliedOrderLevelCoupon = appliedCouponsList.some(
      (c: any) => c?.id && getOfferCategory(c) !== 'FREE_ITEM'
    );
    // FREE_ITEM offers are exempt from exclusivity — same as item-level
    // offers — so they can always be added once min_subtotal is met.
    const blockedByExclusivity = couponCategory !== 'FREE_ITEM' && !isThisCouponApplied && (
      (exclusiveActive) ||
      (thisIsExclusive && hasAppliedOrderLevelCoupon)
    );

    
    // For FREE_ITEM coupons, default `_chosenFreeItemId` to the first
    // entry in freeList so the cart immediately shows a chosen item.
    // Apply does NOT open the picker — the user can swap items later via
    // the chip's Change action in the cart.
    // FREE_ITEM offers with an empty freeList have nothing to give away —
    // block Apply so we don't put a no-op coupon in appliedCoupons.
    const isFreeItemOffer = couponCategory === 'FREE_ITEM';
    const freeListEmpty =
      isFreeItemOffer &&
      !(Array.isArray(couponDetails?.freeList) &&
        couponDetails.freeList.some((itemId: any) => {
          const m = Array.isArray(restaurantMenuDetails)
            ? restaurantMenuDetails.find((menu: any) => menu?.itemId === itemId)
            : null;
          return isMenuItemOrderable(m);
        }));

    // BOGO offers: block Apply until the cart has the full buy qty PLUS at
    // least one get item (the discount scales with whatever get qty the user
    // adds, capped at `bogo.getQty`). For same-item BOGOs the same rule
    // applies against the shared qty pool: `total ≥ buyQty + 1`.
    const isBogoOffer =
      String(couponDetails?.offer_type ?? couponDetails?.offerType ?? '')
        .toUpperCase() === 'BOGO';
    const bogoNotEligible = (() => {
      if (!isBogoOffer) return false;
      const bogo = couponDetails?.bogo;
      if (!bogo) return true;
      const buyItemIds: string[] = (Array.isArray(bogo.buyItems) ? bogo.buyItems : [])
        .map((b: any) => b?.itemId)
        .filter(Boolean);
      const getItemIds: string[] = (Array.isArray(bogo.getItems) ? bogo.getItems : [])
        .map((g: any) => g?.itemId)
        .filter(Boolean);
      const buyQty = Number(bogo.buyQty || 1);
      if (buyItemIds.length === 0 || getItemIds.length === 0) return true;
      const offerId = couponDetails?.id;
      const cartArr = Array.isArray(cart) ? cart : [];
      const isSameItem = buyItemIds.some((id) => getItemIds.includes(id));
      // equalOrLesserValue gate: when set, at least one in-cart get item must
      // be priced ≤ the most-expensive in-cart buy item; otherwise BOGO can't
      // apply and the apply button should stay locked.
      if (!bogoEqualOrLesserSatisfied(bogo, cartArr, buyItemIds, getItemIds)) {
        return true;
      }
      if (isSameItem) {
        const totalSame = cartArr.reduce(
          (sum: number, item: any) =>
            buyItemIds.includes(item?.itemId)
              ? sum + Number(item?.quantity || 0)
              : sum,
          0
        );
        return totalSame < buyQty + 1;
      }
      let buyInCart = 0;
      let getInCart = 0;
      cartArr.forEach((item: any) => {
        const qty = Number(item?.quantity || 0);
        if (qty <= 0) return;
        if (buyItemIds.includes(item?.itemId)) {
          // Don't double-count the buy item if it's also acting as the
          // discounted get target for this same offer.
          const isThisOffersGet =
            item?.offer_data?.offerId === offerId &&
            item?.is_discount_applied === true;
          buyInCart += isThisOffersGet ? 0 : qty;
        }
        if (getItemIds.includes(item?.itemId)) {
          getInCart += qty;
        }
      });
      return !(buyInCart >= buyQty && getInCart >= 1);
    })();

    const belowMinSubtotal = !isThisCouponApplied && minSubtotal > 0 && availableSubTotal < minSubtotal;
    // Order-level (FLAT/PERCENT/FLATFEE) offers are not applicable for event orders.
    const blockedByEventOrder = couponCategory === 'ORDER' && isEventDate;
    const applyDisabled = blockedByExclusivity || freeListEmpty || bogoNotEligible || belowMinSubtotal || blockedByEventOrder;
      if(!orderTypeApplicable)
      {
        return null;
      }
    return (
      <div className="couponCard-wrapper">
        <div
          className="couponCard"
          style={{border: isThisCouponApplied ? "1px solid #e52333":"1.08px solid #E0E0E0"}}
          // onClick={() => {
          //   // if (isThisCouponApplied) return;
          //   // if (blockedByExclusivity) return;
          //   // if (freeListEmpty) return;
          //   // if (bogoNotEligible) return;
          //   // if (belowMinSubtotal) return;
          //   // applyOfferLikeCard(couponDetails);
          // }}
            onClick={e => {
                e.stopPropagation();
                setCouponState(couponDetails);
                setShowCouponDetailsPopup(true);
              }}
        >
         
            <img
            src={cardIconSrc}
            alt=""
            className={cardIconClassName}
            onError={(e) => {
              // If the menu item image fails to load (missing fields, 404),
              // gracefully fall back to the generic FREE_ITEM asset.
              if (couponCategory === 'FREE_ITEM') {
                const img = e.currentTarget;
                if (img.src !== freeItemimg) {
                  img.src = freeItemimg;
                  img.className = 'couponCard-icon couponCard-icon--photo';
                }
              }
            }}
          />
          
          
          <div className="couponCard-left">
            <p className="couponCard-name">{couponDetails?.name}</p>
            <p ref={descRef} className="couponCard-desc">
              {couponDetails?.description || offerText}
            </p>
            <span
              className="couponCard-viewdetails"
              onClick={e => {
                e.stopPropagation();
                setCouponState(couponDetails);
                setShowCouponDetailsPopup(true);
              }}
            >
              View details
            </span>
          </div>

          <div className="couponCard-right">
            {couponDetails?.promoCodes?.length > 0 && (
              <div className="couponCard-promoCode">
                {Array.isArray(couponDetails.promoCodes)
                  ? couponDetails.promoCodes[0]
                  : couponDetails.promoCodes}
              </div>
            )}
            {isThisCouponApplied ? (
              <div
                className="couponCard-remove-button"
                onClick={e => {
                  e.stopPropagation();
                  setPendingRemoveCoupon(couponDetails);
                }}
              >
                Remove
              </div>
            ) : (
              <div
                className={`couponCard-Apply-button ${applyDisabled ? 'disabled-applybtn' : ''}`}
                onClick={e => {
                  e.stopPropagation();
                  if (!blockedByExclusivity && !freeListEmpty && !bogoNotEligible && !belowMinSubtotal && !blockedByEventOrder) {
                    applyOfferLikeCard(couponDetails);
                  }
                }}
              >
                {applyDisabled ? (
                  <img src={locakimg} alt="locked" className="couponCard-Apply-lock" />
                ) : (
                  'Apply'
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="couponList">
      {restaurantDetailLoading || couponsListLoading ? (
        <Shimmer />
      ) : (
        <>
          <div className="couponList-header-container">
            {isMobile && (
              <div className="mobile-view">
                <MenuPageHeader
                  Switch={false}
                  Logoutfn={() => handleLogout('noRedirect')}
                  signupPopup={signupPopup}
                  setSignupPopup={setSignupPopup}
                />
              </div>
            )}
          </div>

          <div
            className="couponList-content"
            style={{
              backgroundColor: isMobile ? '#F1F0F5' : '#f5f5f5',
              marginTop: isMobile ? '0px' : '-0.95rem',
              borderRight: isMobile ? '' : '0.5px solid #606060',
            }}
          >
            <div
              className="couponList-heading"
              style={{ paddingTop: isMobile ? '0.5rem' : '1rem' }}
            >
              {!isMobile && (
                <img
                  src={backArrow}
                  alt=""
                  className="couponList-heading-backArrow"
                  onClick={() => dispatch(couponClicked(false))}
                />
              )}
              <p >Offers</p>
            </div>
            {/* coupon input field */}
            <div className="couponList-search-wrapper">
              <CouponImage className="coupon-image" />
              {/* <img src={couponImage} alt="coupon-image"  /> */}
              <div className="couponList-searchBox">
                <input
                  type="text"
                  className={`couponList-search ${couponSearchError !== '' && !couponCardapplyClicked
                    ? 'couponList-search-error'
                    : ''
                    }`}
                  value={couponSearch}
                  placeholder="Enter Coupon Code"
                  onChange={e => {
                    const value = e.target.value;
                    setCouponSearch(value?.replace(/^\s+/, ''));
                    if (couponSearchError) setCouponSearchError('');
                    if (promoApplySuccess) setPromoApplySuccess(false);
                  }}
                />
                {couponSearch?.length > 0 && (promoApplySuccess || (couponSearchError !== '' && couponSearchError?.message)) && (
                  <img
                    src={clearcoupon}
                    alt="clear"
                    className="couponList-search-clear"
                    onClick={() => {
                      setCouponSearch('');
                      setCouponSearchError('');
                      setPromoApplySuccess(false);
                    }}
                  />
                )}
              </div>
                {!promoApplySuccess && !(couponSearchError !== ''  && couponSearchError?.message) &&
                    <p
                className="couponList-apply-button"
                onClick={() => {
                  // setShowCouponDetailsPopup(true)
                  const alreadyApplied = appliedCouponsList.some(
                    (c: any) => c?.offerCode === couponSearch
                  );
                  if (couponSearch?.length && alreadyApplied) {
                    isMobile
                      ? showErrorToast('Offer already applied')
                      : showErrorToastDesktop('Offer already applied');
                    return;
                  }
                  if (couponSearch?.length && !alreadyApplied) {
                    // ── All promo-code guards (combine + eligibility) ──
                    // Only run when the promo code matches an offer in the
                    // customer-offers list. Unknown codes fall through to the
                    // API, which returns 400 → "Invalid promo code".
                    const matchedOffer = selectedCouponId[0];
                    if (matchedOffer) {
                      // ── Combine / exclusivity checks (mirror CouponCard +
                      //    cart-page auto-apply logic) ──

                      // A2. Cart has item-level offers with a DIFFERENT offerId →
                      //     block only incoming item-level promo codes (ORDER-level
                      //     promo codes can coexist freely with item-level offers).
                      const incomingOfferCat = getOfferCategory(matchedOffer);
                      const existingItemOfferIds = getItemLevelOfferIds(cart);
                      const promoOfferId = String(matchedOffer?.id ?? '');
                      if (
                        existingItemOfferIds.length > 0 &&
                        incomingOfferCat !== 'ORDER' &&
                        incomingOfferCat !== 'FREE_DELIVERY' &&
                        incomingOfferCat !== 'FREE_ITEM' &&
                        incomingOfferCat !== 'BOGO' &&
                        !existingItemOfferIds.includes(promoOfferId)
                      ) {
                        setCouponSearchError({
                          message: 'This item already has an offer applied. Remove it to apply this promo code.',
                        });
                        setPromoLoading(false);
                        return;
                      }

                      // B. Incoming exclusive + ORDER-level offer already applied → block.
                      //    Item-level offers in cart do NOT count as a conflict for
                      //    ORDER-level exclusive promo codes.
                      const incomingExclusive = isExclusiveCoupon(matchedOffer);
                      const anOfferAlreadyApplied = appliedCouponsList.length > 0;
                      if (incomingExclusive && anOfferAlreadyApplied) {
                        const msg =
                          "This offer cannot be combined with the current offer.";
                        isMobile ? showErrorToast(msg) : showErrorToastDesktop(msg);
                        setPromoLoading(false)
                        return;
                      }

                      // C. An exclusive is already applied → blocks all new
                      //    incoming (non-exclusive) offers.
                      const existingExclusiveCoupon = appliedCouponsList.find(
                        (c: any) => isExclusiveCoupon(c)
                      );
                      if (
                        existingExclusiveCoupon &&
                        existingExclusiveCoupon?.id !== matchedOffer?.id
                      ) {
                        const msg = `This offer cannot be combined with the current offer.`;
                        isMobile ? showErrorToast(msg) : showErrorToastDesktop(msg);
                        return;
                      }

                      // D. Same-category conflict (non-BOGO): block only when
                      //    the existing same-category coupon is exclusive
                      //    (combine_offer=true). Two non-exclusive coupons in
                      //    the same category are allowed to stack.
                      const incomingCat = getOfferCategory(matchedOffer);
                      if (incomingCat !== 'BOGO') {
                        const sameCatExisting = appliedCouponsList.find(
                          (c: any) =>
                            getOfferCategory(c) === incomingCat &&
                            c?.id !== matchedOffer?.id &&
                            isExclusiveCoupon(c)
                        );
                        if (sameCatExisting) {
                          const catLabel =
                            incomingCat === 'FREE_ITEM'
                              ? 'free item'
                              : incomingCat === 'FREE_DELIVERY'
                                ? 'free delivery'
                                : 'order level';
                          const msg = `A ${catLabel} offer is already applied. Remove it first to apply this one.`;
                          isMobile ? showErrorToast(msg) : showErrorToastDesktop(msg);
                          return;
                        }
                      }

                      // ── Eligibility checks (min subtotal, BOGO items,
                      //    FREE_ITEM availability) ──
                      const currencySymbol =
                        restaurantDetails?.country === 'IN' ? '₹' : '$';

                      // 1. Minimum subtotal (use available-only subtotal)
                      const minSubtotal = Number(matchedOffer?.min_subtotal ?? 0);
                      if (minSubtotal > 0 && availableSubTotal < minSubtotal) {
                        const remaining = (minSubtotal - availableSubTotal).toFixed(2);
                        const msg = `Add items worth ${currencySymbol}${remaining} more to apply this offer.`;
                        isMobile ? showErrorToast(msg) : showErrorToastDesktop(msg);
                        return;
                      }

                      // 2. BOGO: buy items + at least one get item must be in cart
                      const isBogoPromo =
                        String(matchedOffer?.offer_type ?? matchedOffer?.offerType ?? '')
                          .toUpperCase() === 'BOGO';
                      if (isBogoPromo) {
                        const bogo = matchedOffer?.bogo;
                        const buyItemIds: string[] = (
                          Array.isArray(bogo?.buyItems) ? bogo.buyItems : []
                        )
                          .map((b: any) => b?.itemId)
                          .filter(Boolean);
                        const getItemIds: string[] = (
                          Array.isArray(bogo?.getItems) ? bogo.getItems : []
                        )
                          .map((g: any) => g?.itemId)
                          .filter(Boolean);
                        const buyQty = Number(bogo?.buyQty || 1);
                        const cartArr = Array.isArray(cart) ? cart : [];
                        const isSameItem = buyItemIds.some((id) =>
                          getItemIds.includes(id)
                        );

                        let bogoIneligible = false;
                        if (!bogo || buyItemIds.length === 0 || getItemIds.length === 0) {
                          bogoIneligible = true;
                        } else if (
                          !bogoEqualOrLesserSatisfied(bogo, cartArr, buyItemIds, getItemIds)
                        ) {
                          bogoIneligible = true;
                        } else if (isSameItem) {
                          const totalSame = cartArr.reduce(
                            (sum: number, item: any) =>
                              buyItemIds.includes(item?.itemId)
                                ? sum + Number(item?.quantity || 0)
                                : sum,
                            0
                          );
                          bogoIneligible = totalSame < buyQty + 1;
                        } else {
                          let buyInCart = 0;
                          let getInCart = 0;
                          cartArr.forEach((item: any) => {
                            const qty = Number(item?.quantity || 0);
                            if (qty <= 0) return;
                            if (buyItemIds.includes(item?.itemId)) {
                              const isThisOffersGet =
                                item?.offer_data?.offerId === matchedOffer?.id &&
                                item?.is_discount_applied === true;
                              buyInCart += isThisOffersGet ? 0 : qty;
                            }
                            if (getItemIds.includes(item?.itemId)) getInCart += qty;
                          });
                          bogoIneligible = !(buyInCart >= buyQty && getInCart >= 1);
                        }
                        if (bogoIneligible) {
                          const msg =
                            'Add the required buy and get items to your cart to apply this BOGO offer.';
                          isMobile ? showErrorToast(msg) : showErrorToastDesktop(msg);
                          return;
                        }
                      }

                      // 3. FREE_ITEM: freeList must not be empty (nothing to give)
                      const offerCat = getOfferCategory(matchedOffer);
                      if (
                        offerCat === 'FREE_ITEM' &&
                        !(
                          Array.isArray(matchedOffer?.freeList) &&
                          matchedOffer.freeList.length > 0
                        )
                      ) {
                        const msg = 'This free item offer is not available right now.';
                        isMobile ? showErrorToast(msg) : showErrorToastDesktop(msg);
                        return;
                      }
                    }
                    // ── End guards ──

                    const payload = {
                      customerId: UserId,
                      couponCode: couponSearch,
                      locationId: restaurantDetails?.id,
                      orderTotal: itemTotal,
                      couponId: selectedCouponId[0]?.id,
                    };
                    setCouponCardapplyClicked(false);
                    setPromoLoading(true);
                    dispatch(validateCouponRequest(payload));
                  }
                }}
              >
                Apply
              </p>
              }

            </div>
            {/* coupon input field */}
            {couponSearchError !== '' && !couponCardapplyClicked && (
              <div className="coupon-validate-error">
                <p className="coupon-validate-error-text">{couponSearchError?.message}</p>
              </div>
            )}

            <div className="couponList-coupon-list">
              <div
                className="couponList-coupon-list-wrapper">
                {couponsList?.length > 0 ? (
                  (couponsList ?? []).map((coupon: any) => {
                    return (
                      <CouponCard
                        key={coupon?.id}
                        couponDetails={coupon}
                      />
                    );
                  })
                ) : (
                <div className='No-Offers-container'>
                     <img src={notFound} alt="" className="couponList-not-found" />
                     <p className='No-offers-text1'>No offers available right now</p>
                     <p className='No-offers-text2'>Check back soon, New deals are on the way</p>
                </div>
               
                )}
              </div>
            </div>
          </div>
        </>
      )}

      <CouponDetailsModal
        couponDetails={couponState}
        open={showCouponDetailsPopup}
        onApply={() => {
          // Apply the same way the coupon card does, then close the sheet.
          applyOfferLikeCard(couponState);
          setShowCouponDetailsPopup(false);
        }}
        onClose={() => {
          setShowCouponDetailsPopup(false);
        }}
      />

      {/* <InvalidCoupon
        open={showCouponPopup}
        onClose={() => {
          dispatch(validateCouponClearmsg());
          dispatch(clearPlaceOrderLoading());
          setShowCouponPopup(false);
        }}
      /> */}
      {
        // couponCardapplyClicked &&
           <CouponAppliedModal
           couponDetails={couponState}
          open={isMobile ? !!showSuccessPopupMobile : !!showSuccessPopup}
          onClose={() => {
            setShowSuccessPopupMobile(false);
            if (!isMobile) {
              dispatch(couponClicked(false));
              setShowSuccessPopup(false);
            } else {
              if (tableId) {
                navigate(
                  `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/table/${tableId}/menu/${slugFromLocalStorage?.menuType}/contactlessdinein/cart`
                );
              } else {
                navigate(`/${merchantType}/${merchantSlug}/cart`);
              }
            }
          }}
/>
      }

   
      {/* {couponCardapplyClicked && (
        <CouponSuccessPopup
          couponDetails={couponState}
          open={(isMobile ? showSuccessPopupMobile : showSuccessPopup) || validateCouponSuccess}
          onClose={() => {
            setShowSuccessPopupMobile(false);
            if (!isMobile) {
              dispatch(couponClicked(false));
              setShowSuccessPopup(false);
            } else {
              if (tableId) {
                navigate(
                  `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/table/${tableId}/menu/${slugFromLocalStorage?.menuType}/contactlessdinein/cart`
                );
              } else {
                navigate(`/${merchantType}/${merchantSlug}/cart`);
              }
            }
          }}
        />
      )} */}

      <CouponRemovePopup
        open={!!pendingRemoveCoupon}
        isMobile={isMobile}
        onKeep={() => setPendingRemoveCoupon(null)}
        onRemove={() => {
          const coupon = pendingRemoveCoupon;
          if (coupon) {
            // Dismiss THIS specific offer at the current RAW cart subtotal
            // (qty × base+modifier prices, ignoring any applied discount).
            // Per-offer (not per-category) so removing one FREE_ITEM coupon
            // doesn't suppress the others.
            //
            // Raw is critical: when the user removes BOGO, the cart-watcher
            // restores the get-item's full price on its very next tick,
            // which would raise a `Σ item.subTotal` snapshot above its
            // stored value and immediately release the dismissal — causing
            // the offer to instantly re-auto-apply. The raw sum is stable
            // across that toggle.
          

            dismissOfferAtSubtotal(coupon?.id, computeRawCartSubtotal(cart));
            // Removing an AUTO-applied offer suppresses all further auto-apply
            // (every coupon category + BOGO) until the user manually applies
            // one. Manually-applied (promo-code) offers don't trip this.
            if (wasAutoApplied(coupon)) suppressAllAutoApply();
            // Remove only this coupon — leave other stacked coupons intact.
            dispatch(clearAppliedCoupon({ id: coupon?.id }));
            isMobile ? showErrorToast("Offer removed successfully") : showErrorToastDesktop("Offer removed successfully");
          }
          setPendingRemoveCoupon(null);
        }}
      />
    </div>
  );
};

export default CouponList;
